<template>
  <Modal
    :open="openSuccessRegistration"
    class="registration"
    :hasCloseButton="false"
  >
    <div class="registration-modal">
      <p class="registration-modal__title">{{ $t('auth.congratulations') }}</p>
      <p class="registration-modal__text">{{ $t('auth.congratsText') }}</p>
      <div class="registration-modal__action">
        <BaseButton btnColor="gold" label="ok" @setAction="closeModal" />
      </div>
    </div>
  </Modal>
</template>

<script>
import BaseButton from '../base/BaseButton.vue'
import Modal from '../Modal.vue'
export default {
  name: 'SuccessRegistration',
  components: { Modal, BaseButton },

  computed: {
    openSuccessRegistration() {
      return this.$store.getters.openSuccessRegistration
    }
  },

  methods: {
    closeModal() {
      this.$store.dispatch('setSuccessRegistration', false)
      this.$router.replace({ 'query': null })
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/modals/success_registration.scss';
</style>



// WEBPACK FOOTER //
// src/components/modal/SuccessRegistration.vue